import { defineComponent, h } from 'vue';
import VueRecaptcha from 'vue-recaptcha';

interface ReCaptchaProps {
  show: boolean;
}

export const ReCaptcha = defineComponent<ReCaptchaProps>({
  name: 'ReCaptcha',
  props: ['show'],
  setup(props, { emit }) {
    return function render() {
      if (!props.show) {
        return null;
      }

      return h(VueRecaptcha, {
        props: {
          sitekey: process.env.VUE_APP_GOOGLE_RECAPTCHA_SITE_KEY,
          loadRecaptchaScript: true,
        },
        on: {
          verify: () => emit('input', true),
          error: () => emit('input', false),
          expired: () => emit('input', false),
        },
        class: 'google-recaptcha',
      });
    };
  },
});
